var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgOptimism = function SvgOptimism(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "#F80521"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "url(#F80521)",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.553 23.137c-.853 0-1.563-.16-2.133-.479a3.1 3.1 0 0 1-1.278-1.34c-.288-.578-.431-1.255-.431-2.03 0-.52.048-1.037.143-1.552a7.573 7.573 0 0 1 .438-1.49c.196-.483.442-.93.738-1.34.296-.41.645-.768 1.046-1.073a4.69 4.69 0 0 1 1.36-.725 5.25 5.25 0 0 1 1.696-.26c1.23 0 2.162.351 2.796 1.053.638.702.957 1.634.957 2.796 0 .52-.048 1.04-.144 1.559a7.69 7.69 0 0 1-.424 1.497 6.15 6.15 0 0 1-.717 1.333c-.292.41-.636.77-1.033 1.08a4.61 4.61 0 0 1-1.34.718 5.232 5.232 0 0 1-1.674.253Zm.232-2.208c.223 0 .438-.05.643-.15.205-.1.396-.242.574-.424a3.08 3.08 0 0 0 .485-.664 5.04 5.04 0 0 0 .376-.854c.105-.314.185-.65.24-1.005.054-.355.082-.725.082-1.107 0-.515-.11-.921-.329-1.217-.218-.296-.535-.444-.95-.444-.25 0-.485.056-.704.17a2.258 2.258 0 0 0-.608.472 3.57 3.57 0 0 0-.492.704c-.146.269-.272.56-.376.875-.1.315-.178.64-.233.978a6.88 6.88 0 0 0-.075 1.011c0 .36.05.663.15.91.105.246.258.432.458.56.205.123.458.185.76.185ZM18.548 23l2.112-9.994h2.55c.884 0 1.593.132 2.126.396.538.265.927.625 1.169 1.08.246.452.369.958.369 1.518 0 .597-.107 1.126-.321 1.586-.21.456-.51.84-.903 1.155-.387.31-.85.545-1.387.704a6.15 6.15 0 0 1-1.77.24h-.589L21.221 23h-2.673Zm3.835-5.503h.43c.283 0 .527-.061.732-.184.21-.123.371-.292.485-.506.114-.215.171-.456.171-.725a.96.96 0 0 0-.219-.615c-.14-.187-.376-.28-.704-.28h-.403l-.492 2.31Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 18 -18 0 18 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80521"
  })))));
};
export default SvgOptimism;